<template>
  <section>
    <ContainerBasic class="-mx-4 w-[calc(100%_+_2rem)] py-5 lg:py-32">
      <slot />
    </ContainerBasic>
  </section>
</template>
